// extracted by mini-css-extract-plugin
export default {"templateTwo":"S_cN","imgContainer":"S_b7","headerContainer":"S_cT","bonusText":"S_dj","tnc":"S_cy","blendColors":"S_dk"};